export default __webpack_public_path__ + "static/media/192.376b7db9.png";